<script setup lang="ts">
import { BREAKPOINTS } from "@/consts";
import Button from "@/stories/buttons/Button/Button.vue";
import { useBreakpoints } from "@vueuse/core";

const breakpoints = useBreakpoints(BREAKPOINTS);
const isMobile = breakpoints.smaller("desktop");

interface Props {
  count: number;
}

defineProps<Props>();

defineEmits<{ close: []; apply: [] }>();
</script>

<template>
  <div
    :class="[
      'flex space-between items-center fixed left-0 bottom-0 bg-white w-full p-6 border-t mt-1 border-neutral300',
      'tablet:relative tablet:border-none',
    ]"
  >
    <div v-if="!isMobile" class="flex-grow h600 text-darkOcean600">
      {{ $t("templates.amount_images_chosen_new", { count }) }}
    </div>
    <Button
      v-if="!isMobile"
      :text="$t('templates.cancel')"
      type="white"
      class="mr-2"
      @click="$emit('close')"
    />
    <Button
      type="primary"
      :text="$t('global.use')"
      :full-width="isMobile"
      :size="isMobile ? 'lg' : 'md'"
      @click="$emit('apply')"
    />
  </div>
</template>
